import { useContext } from 'react';
import {
    WebsocketContext,
    WebsocketPayloadCountMessages,
    WebsocketPayloadListMessage,
    WebsocketPayloadMessage,
} from './WebsocketContext';

/**
 * Hook React pour gérer un WebSocket lié à un topic donné.
 *
 * @param topicId Identifiant unique du topic (ex : messagerie_dossier_formalite_42)
 * @param topicType Type de topic (ex : messagerie_dossier_formalite)
 * @param onMessage Fonction à appeler à chaque message reçu
 */
export const useWebsocket = () => {
    const context = useContext(WebsocketContext);

    if (!context) {
        throw new Error('useWebsocket must be used within a WebsocketProvider');
    }

    const { createSocket: contextCreateSocket, getSocket, getError, sendOnSocket } = context;

    const createSocket = (topicId: string) => {
        contextCreateSocket();

        return {
            sendOnSocket: (
                payload:
                    | (WebsocketPayloadMessage & { action: string })
                    | (WebsocketPayloadListMessage & { action: string })
                    | (WebsocketPayloadCountMessages & { action: string }),
                actionExpected: string,
            ) => sendOnSocket(payload, actionExpected),
            socket: getSocket(),
            close: () => {},
            error: getError(topicId),
        };
    };

    return createSocket;
};
